import { render, staticRenderFns } from "./TehtavaMallitHallitus.vue?vue&type=template&id=744e4873"
import script from "./TehtavaMallitHallitus.vue?vue&type=script&lang=js"
export * from "./TehtavaMallitHallitus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports